<template>

  <div class="photo-box">
    <div class="photo">
      <Avatar
        :src="imgSrc"
        :name="candidate.name"
        size="100px"
        radius="7px"
        resize="100x100x1" />
    </div>
    <div
      v-if="permissions.includes('manage_candidates')"
      class="actions">
      <a
        href="javascript:void(0)"
        class="btn btn-sm btn-default"
        @click.stop="editSection(true)" v-if="!sectionEdit">
        <i class="fas fa-pencil-alt" />
        </a>
      <div
        v-if="sectionEdit"
        class="btn-group btn-group-sm btn-group-actions"
        :class="{'box-loading': loading}">
        <label
          class="btn btn-default text-primary">
          <i class="fas fa-upload" />
          <input
            type="file"
            class="form-control"
            @change="uploadFile($event)"
            style="display: none;">
        </label>
        <a
          href="javascript:void(0)"
          class="btn btn-default text-danger"
          @click.stop="removePhoto()"
          v-if="candidate.photo_media_url">
          <i class="fas fa-trash-alt" />
        </a>
        <a
          href="javascript:void(0)"
          class="btn btn-default text-secondary"
          @click.stop="editSection(false)">
          <i class="fas fa-times" />
        </a>
      </div>
    </div>
  </div>


</template>

<script>
import config from '@/config'
// import FileReader from '@/utils/FileReader'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'CandidatePhoto',
  components: {
    Avatar
  },
  data () {
    return {
      loading: false,
      sectionEdit: false,
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.candidate.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  methods: {
    /*
    editSection
    */
    editSection (status) {
      this.sectionEdit = status
    },
    /*
    uploadFile
    */
    uploadFile (event) {
      this.loading = true

      const file = event.target.files[0]

      const formData = new FormData()
      formData.append('file', file)
      return this.$store.dispatch('createMediaMultipart', formData)
      // FileReader(file)
      // .then((response) => {
      //   return this.$store
      //   .dispatch('createMedia', {
      //     'title': file.name,
      //     'base64': response
      //   })
      // })
      .then((response) => {
        return this.$store.dispatch('updateCandidate', {
          _id: this.candidate._id,
          photo_media_id: response
        })
      })
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    removePhoto
    */
    removePhoto () {
      return this.$store.dispatch('updateCandidate', {
        _id: this.candidate._id,
        photo_media_id: null
      }).then(() => {
        this.sectionEdit = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.photo-box {
  position: relative;
}
.photo-box > .photo {
  width: 100px;
  height: 100px;
}
.photo-box > .actions {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.btn-group-actions{
  display: flex;
  margin: 0;
  background: rgba(255,255,255,0.8);
  border-radius: 3px;
}
  .btn-group-actions > *{
    flex: 1;
    margin: 0;
    border: 0;
  }
  .btn-group-actions > *:hover{
    background: #ffffff;  
  }
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Header/CandidatePhoto.vue